import React from 'react';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

export const NextIcon: React.FC<React.PropsWithChildren<unknown>> = () => {
	return <FontAwesomeIcon icon={faChevronRight} />;
};

export default NextIcon;
